import Styles from './MobileHeader.module.scss'
import { PropsWithChildren } from 'react'
import { useHeaderTheme } from 'hooks/useHeaderTheme'
import { Button } from 'blaze-ui/Button'
import { Heading } from 'blaze-ui/Heading/Heading'

export const MobileHeader = ({ children, onBack }: PropsWithChildren<{ onBack: () => void }>) => {
  const theme = useHeaderTheme()

  return (
    <div className={Styles.header} data-theme={theme}>
      <div />
      <Heading level={5} lineClamp={1}>
        {children}
      </Heading>
      <Button variant="ghost" size="md" onPress={onBack}>
        Cancel
      </Button>
    </div>
  )
}
